import { RouteProp, useRoute, useNavigation } from '@react-navigation/native';
import { TNavigationStackWithParams } from 'app/types';
import { MainLayout } from '@shared/components/md-design-system/Layout/MainLayout';
import { ActivityName } from '../types';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { MeasurementForm } from '../components/forms';

const MeasurementSubmitFormScreen = () => {
    const route = useRoute<RouteProp<TNavigationStackWithParams<{ activityName: ActivityName, activityId: string }>, 'MeasurementSubmit'>>();
    const navigation = useNavigation<NativeStackNavigationProp<TNavigationStackWithParams<{ activityName: ActivityName, initialStep: number, activityId: string, result?: any, autoStartWebSocket?: boolean } | undefined>>>();

    const activityName = route.params?.activityName;
    const activityId = route.params?.activityId;

    const handleGoToMeasurementStep = () => {
        navigation.navigate("MeasurementFlow", {
            activityName: activityName,
            initialStep: 2,
            activityId: activityId || "",
            autoStartWebSocket: true,
        });
    };

    const handleGoToHome = () => {
        navigation.navigate("Homepage");
    }

    return (
        <MainLayout navigation={handleGoToHome} scrollable={true}>
            <MeasurementForm activityName={activityName} handleGoToMeasurementStep={handleGoToMeasurementStep} />
        </MainLayout>
    );
};

export default MeasurementSubmitFormScreen;